<template>
  <btn
    class="country-selector-btn"
    :class="{
      'mobile-flag-only': mobileFlagOnly,
      'country-selector-btn__footer': location === 'footer',
    }"
    modifiers="text"
    @click.prevent="handleCountrySelectToggle"
  >
    <template #icon>
      <span
        class="country-selector-btn__flag"
        v-html="flagIcon"
      />
      <span
        class="country-selector-btn__label text-other-button-s"
        :class="{
          'visually-hidden': location !== 'footer',
        }"
        v-text="currentCountry"
      />
      <icon-caret-down />
    </template>
  </btn>
</template>

<script>

/**
 * Vue: Country selector btn (country-selector-btn)
 * -----------------------------------------------------------------------------
 * Global country selector button.
 *
 */
import { mapActions } from 'vuex'

import Btn from '~global/btn/btn'
import IconCaretDown from '~icons/directional-navigation/caret/down.svg'

export default {
  name: 'CountrySelectorBtn',

  components: {
    Btn,
    IconCaretDown,
  },

  props: {
    mobileFlagOnly: {
      type: [Boolean, String],
      default: false,
    },
    location: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      cnvsGlobal: true,
      currentCountry: `${cnvs.store.countryName}`,
      flagIcon: cnvs.strings.defaultLocalization?.flag_svg,
    }
  },

  mounted() {
    // Not empty
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      toggleOverlay: 'overlays/toggle',
    }),

    /**
     * Handle country select toggle.
     */
    handleCountrySelectToggle() {
      this.toggleOverlay({
        component: 'country-selector',
        ignoreDismissed: true,
        namespace: 'countrySelector',
      })
    },
  },
}
</script>
